/**
 * ETERNITY INTELLIGENCE — NEW MOBILE BOTTOM NAVIGATION
 * Consumer-app style navigation
 */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Users, Sparkles, FileText, User } from 'lucide-react';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      id: 'home',
      label: 'HOME',
      icon: Home,
      path: '/intelligence',
      activeColor: '#E85002'
    },
    {
      id: 'clients',
      label: 'CLIENTS',
      icon: Users,
      path: '/intelligence/clients',
      activeColor: '#F16001'
    },
    {
      id: 'ai',
      label: 'AI',
      icon: Sparkles,
      path: '/intelligence/ask',
      activeColor: '#FF6129',
      special: true
    },
    {
      id: 'website',
      label: 'WEBSITE',
      icon: FileText,
      path: '/intelligence/website',
      activeColor: '#E85002'
    },
    {
      id: 'me',
      label: 'ME',
      icon: User,
      path: '/intelligence/me',
      activeColor: '#C10801'
    }
  ];

  const isActive = (path) => {
    if (path === '/intelligence') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden"
      style={{
        background: 'rgba(17, 17, 17, 0.95)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.05)',
        paddingBottom: 'max(8px, env(safe-area-inset-bottom))'
      }}
    >
      <div className="flex items-center justify-around px-2 py-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center gap-0.5 transition-all duration-300 relative"
              style={{
                flex: 1,
                padding: '6px',
                minHeight: '52px',
                minWidth: '52px'
              }}
            >
              {/* AI center button with special emphasis */}
              {item.special ? (
                <div
                  className="relative flex items-center justify-center"
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    background: active
                      ? `linear-gradient(135deg, ${item.activeColor} 0%, #C10801 100%)`
                      : 'linear-gradient(135deg, rgba(255, 97, 41, 0.3) 0%, rgba(193, 8, 1, 0.3) 100%)',
                    marginTop: '-24px',
                    border: active ? 'none' : '1px solid rgba(255, 97, 41, 0.3)',
                    boxShadow: active
                      ? '0 8px 24px rgba(255, 97, 41, 0.4)'
                      : '0 4px 16px rgba(255, 97, 41, 0.2)'
                  }}
                >
                  <Icon
                    size={22}
                    strokeWidth={active ? 2.5 : 2}
                    style={{
                      color: '#FFFFFF'
                    }}
                  />
                </div>
              ) : (
                <>
                  {/* Regular icon */}
                  <div
                    className="relative flex items-center justify-center"
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      background: active
                        ? `radial-gradient(circle, ${item.activeColor}20 0%, transparent 70%)`
                        : 'transparent'
                    }}
                  >
                    <Icon
                      size={20}
                      strokeWidth={active ? 2 : 1.5}
                      style={{
                        color: active ? item.activeColor : '#A7A7A7',
                        transition: 'all 0.3s'
                      }}
                    />
                  </div>
                  
                  {/* Label */}
                  <span
                    className="text-[9px] font-medium tracking-wider mt-0.5"
                    style={{
                      color: active ? item.activeColor : '#646464',
                      transition: 'all 0.3s'
                    }}
                  >
                    {item.label}
                  </span>

                  {/* Active indicator dot */}
                  {active && (
                    <div
                      className="absolute -bottom-0.5"
                      style={{
                        width: '3px',
                        height: '3px',
                        borderRadius: '50%',
                        background: item.activeColor
                      }}
                    />
                  )}
                </>
              )}
            </button>
          );
        })}
      </div>

    </nav>
  );
};

export default BottomNav;
